// extracted by mini-css-extract-plugin
module.exports = {"popupContainer":"styles_popupContainer__2ZFVa","header":"styles_header__1TDDw","description":"styles_description__1Pazm","button":"styles_button__2lgyK"};